module.exports = __webpack_public_path__ + "img/shop03.924d5ae9.png";